import { useState } from "react";
import { publish, useSubscribe } from "./Messages";

const authkeyCache = "";

const useAuthkey = () => {
  const [authkey, setAuthkey] = useState(authkeyCache);

  if (!authkey) publish.queryAuthToken();
  useSubscribe((message) => {
    if (
      message.type === "EVENT:AUTH_TOKEN" &&
      message.payload &&
      typeof message.payload === "object"
    ) {
      const payload = message.payload as { token?: unknown };
      if (typeof payload.token === "string" && payload.token.length > 0) {
        setAuthkey(payload.token);
      }
    }
  });

  return authkey;
};

export { useAuthkey };
